<script setup lang="ts">
import './assets/style.scss'
import type { PropType } from 'vue'
import { VIcons } from '@/shared/ui'
import type { ObjectMapPrintItem } from '../model/api.ts'
import { usePrintObjectMaps } from '../model/api.ts'
import { useHelpers } from '@/shared/lib'

const props = defineProps({
  objects: {
    type: Array as PropType<ObjectMapPrintItem[]>,
    default: () => [],
  },
})

const { print, isPending } = usePrintObjectMaps()
const { printFile } = useHelpers()

/**
 * Функция обработки печать с карты
 */
const printHandler = () => {
  print(props.objects).then((data) => {
    if (data) printFile(data.data)
  })
}
</script>

<template>
  <VTooltip location="top" :open-delay="500" :text="$t('itf.print')">
    <template #activator="{ props: tooltipProps }">
      <VBtn :loading="isPending" v-bind="tooltipProps" @click.stop="printHandler">
        <VIcons type="print" bold />
      </VBtn>
    </template>
  </VTooltip>
</template>
